/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';

import {Row, Col } from 'react-bootstrap';

import MicrositePanel from '../../../MicrositePanel/MicrositePanel';

import MicrositeSectionBasic from '../MicrositeSectionBasic/MicrositeSectionBasic';
import MicrositeSection from '../MicrositeSection';

import styles from './MicrositeSectionPanels.css';


class MicrositeSectionPanels extends MicrositeSectionBasic {
    constructor(props) {
        super(props);
        this.state = {
            modals: {}
        };
    }

    render() {
        let highlighted = false;
        if (this.props.panelsHighlighted){
            highlighted = true;
        }

        let content = [];
        content.push(this.renderIntroduction());
        content.push(this.renderGrid("microsite-panels", this.props.maxItemsInRow, this.props.panels));

        return (
            <MicrositeSection
                id={this.props.id}
                name={this.props.name}
                textCentered={this.props.textCentered}
                colorTheme={this.props.colorTheme}
                content={content}
                highlighted={highlighted}
            />
        );
    }

    /**
     * Render Panel
     * @param data {Object}
     */
    renderItem(data){
        let showModal = false;
        if (data.id && this.state.modals[data.id]){
            showModal = this.state.modals[data.id];
        }
        if (this.props.panelsHighlighted){
            return (
                <MicrositePanel
                    id={data.id}
                    links={data.links}
                    modal={data.modal}
                    showModal={showModal}
                    panelHighlighted
                    image={data.image}
                    title={data.title}
                    text={data.text}
                />
            );
        } else {
            return (
                <MicrositePanel
                    id={data.id}
                    links={data.links}
                    modal={data.modal}
                    image={data.image}
                    showModal={showModal}
                    title={data.title}
                    text={data.text}
                />
            );
        }
    }
}

MicrositeSectionPanels.propTypes = {
    maxItemsInRow: PropTypes.number,
    panelsHighlighted: PropTypes.bool,
    panels: PropTypes.array
};

export default MicrositeSectionPanels;